//#region src/core/ui/play-button/data.ts
/** @internal */
const PlayButtonDataAttrs = {
	/** Present when the media is paused. */
	paused: "data-paused",
	/** Present when the media has ended. */
	ended: "data-ended",
	/** Present when playback has started. */
	started: "data-started"
};
//#endregion
export { PlayButtonDataAttrs };
